/**
 * @preserve
 * Licenses of bundled dependencies can be found in dependencies-licenses.txt
 */
var applyClass=function(a,s,l){if(l){a.classList.add(s)}else{a.classList.remove(s)}};export{applyClass as a};
//# sourceMappingURL=apply-class-b5311833.js.map